<template>
    <div class="create">
        <h2>致力于为用户创造高品质的<br/>移动互联网产品</h2>
        <div class="img-con">
            <div class="img-item bg-img1">
                <div class="con">
                    <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs/16.png" />
                    <div class="name">高端APP开发</div>
                </div>
            </div>
            <div class="img-item bg-img2">
                <div class="con">
                    <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs/18.png" />
                    <div class="name">⼩程序定制</div>
                </div>
            </div>
            <div class="img-item bg-img3">
                <div class="con">
                    <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs/20.png" />
                    <div class="name">⽹页设计</div>
                </div>
            </div>
            <div class="img-item bg-img4">
                <div class="con">
                    <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs/22.png" />
                    <div class="name">软件开发</div>
                </div>
            </div>
        </div>
        <div class="menu">
            <div class="menu-con">
                <div class="menu-item">
                    <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/logos/icon_01%402x%20(1).png" class="imgs" />
                    <div class="r-con">
                        <div class="title">UI界面设计</div>
                        <div class="info">精确捕捉用户需求，将移动应用开发转化为直观、美观、易用的界面体验。</div>
                    </div>
                </div>
                <div class="menu-item">
                    <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/logos/icon_02%402x%20(1).png" class="imgs" />
                    <div class="r-con">
                        <div class="title">UX交互设计</div>
                        <div class="info">通过深入了解用户需求和行为，创造出直观、流畅、令人愉悦的用户界面交互体验</div>
                    </div>
                </div>
                <div class="menu-item">
                    <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/logos/icon_03%402x.png" class="imgs" />
                    <div class="r-con">
                        <div class="title">产品原型设计</div>
                        <div class="info">将产品概念转化为可视化、交互性强的模型，以便验证和优化用户体验，提供实际参考和指导。</div>
                    </div>
                </div>
                <div class="menu-item">
                    <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/logos/icon_04%402x.png" class="imgs" />
                    <div class="r-con">
                        <div class="title">全市场应用</div>
                        <div class="info">设计和开发适用于各个市场和用户群体的应用程序，以实现广泛的用户覆盖和满足不同需求。</div>
                    </div>
                </div>
                <div class="menu-item">
                    <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/logos/icon_05%402x.png" class="imgs" />
                    <div class="r-con">
                        <div class="title">web网页设计</div>
                        <div class="info">创造吸引人、易用且功能丰富的网页，提供优秀用户体验和有效信息传达。</div>
                    </div>
                </div>
                <div class="menu-item">
                    <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/logos/icon_06%402x.png" class="imgs" />
                    <div class="r-con">
                        <div class="title">手机应用</div>
                        <div class="info">设计和开发功能丰富、界面友好的移动应用程序，以满足用户需求并提供优秀的移动体验。</div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped lang="scss">
    .create{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 51px;
        box-sizing: border-box;
        h2{
            font-size: 34px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #000B33;
            line-height: 51px;
            text-align: center;
        }
        .img-con{
            margin-top: 77px;
            display: flex;
            align-items: center;
            gap: 63px;
            .img-item{
                width: 237px;
                height: 237px;
                background-position: center;
                background-size: cover;
                background-repeat: no-repeat;
                display: flex;
                align-items: center;
                justify-content: center;
                .con{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap:10px;
                    img{
                        width: 40px;
                        height: 43px;
                    }
                    .name{
                        font-size: 15px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #FFFFFF;
                        line-height: 21px;
                    }
                }
            }
            .bg-img1{
                background-image: url("https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs/Image\ 15@2x.png");
            }
            .bg-img2{
                background-image: url("https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs/Image\ 17@2x.png");
            }
            .bg-img3{
                background-image: url("https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs/Image\ 19@2x.png");
            }
            .bg-img4{
                background-image: url("https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs/Image\ 21@2x.png");
            }
        }
        .menu{
            margin-top: 110px;
            width: 100%;
            .menu-con{
                width: 1200px;
                margin:0px auto 0;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                gap: 50px;
            }
            .menu-item{
                display: flex;
                .imgs{
                    width: 80px;
                    height: 80px;
                    margin-top: -30px;
                }
                .r-con{
                    margin-left: 30px;
                    .title{
                        font-size: 24px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #000000;
                        line-height: 33px;
                    }
                    .info{
                        width: 255px;
                        font-size: 18px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                        line-height: 28px;
                        margin-top: 8px;
                    }
                }
            }
        }
    }
</style>